import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=5e734add&scoped=true"
var script = {}
import style0 from "./account-detail.vue?vue&type=style&index=0&id=5e734add&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e734add",
  null
  
)

export default component.exports